// Shared cva variants for the Sidebar family. Pulled out so the
// SidebarContent component file stays under the LOC ceiling and the
// variant config is colocated with anything else that needs it.

import { cva } from 'class-variance-authority'

export const sidebarVariants = cva(
  'group/sidebar flex h-full flex-col bg-sidebar text-sidebar-foreground',
  {
    variants: {
      variant: {
        sidebar: '',
        floating: 'absolute inset-y-0 z-10',
        inset: '',
      },
    },
    defaultVariants: {
      variant: 'sidebar',
    },
  },
)
